import { getComponentTopCoordinates } from "./getComponentTopCoordinates";
export var getActiveOnScroll = function getActiveOnScroll(menuItems) {
  var topCoordinates = getComponentTopCoordinates(menuItems).map(function (item) {
    return item.top;
  });
  var closestComponent = getComponentTopCoordinates(menuItems).filter(function (item) {
    return item.top === Math.min.apply(Math, topCoordinates);
  });
  return closestComponent[0].text;
};